module.exports = __webpack_public_path__ + "img/5.fee4107f.jpeg";